<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/ues-portals.png">
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";
import { redirectToUesPortals } from "@/utils/uesPortalsRedirect";

export default {
  name: "UESPortals",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('UESPortals SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/uesportals/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/uesportals/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goUESPortals()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/uesportals/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/uesportals/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.goUESPortals()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goUESPortals() {
      redirectToUesPortals(this.userData, this.secretKey);
    },
  }
}
</script>
